<template>
  <div>
    <v-combobox :items="allergens" label="Allergen:" v-model="allergen.Name">
    </v-combobox>
    <v-text-field label="SPT in mm:" v-model="allergen.MmSpt"> </v-text-field>
    <v-text-field label="Percentage:" v-model.number="allergen.Percentage">
    </v-text-field>
    <v-btn @click="addItem">Add Allergen</v-btn>
    <br />
    <br />
    <v-data-table
      :headers="headers"
      :items="items"
      item-key="Id"
      hide-actions
      class="elevation-1 bor"
    >
      <template slot="items" slot-scope="props">
        <tr>
          <td>{{ props.item.Name }}</td>
          <td>{{ props.item.MmSpt }}</td>
          <td>{{ props.item.Percentage }}</td>
          <td style="text-align: center">
            <v-btn outline small icon @click="removeItem(props.item)">
              <v-icon class="red--text text--darken-1"
                >fa fa-minus-circle</v-icon
              >
            </v-btn>
            <!--<v-btn small icon depressed>-->
            <!--<v-icon color="grey darken-1">fa fa-trash</v-icon>-->
            <!--</v-btn>-->
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: ["items"],
  data() {
    return {
      headers: [
        {
          text: "Name",
          value: "Name",
          sortable: true,
          width: "10%"
        },
        {
          text: "SPT results in mm",
          value: "MmSpt",
          sortable: true,
          width: "10%"
        },
        {
          text: "Percentage",
          value: "Percentage",
          sortable: true,
          width: "10%"
        },
        {
          text: "Actions",
          value: "",
          sortable: false,
          width: "5%",
          align: "center"
        }
      ],
      allergens: ["D. Farinae", "D. Pteronyssinus", "Blomia", "Cockroach"],
      allergen: {
        Name: "",
        MmSpt: "",
        Percentage: 0
      }
    };
  },
  methods: {
    addItem() {
      if (!this.allergen.Name) {
        return;
      }
      if (!this.allergen.MmSpt) {
        return;
      }
      if (!this.allergen.Percentage) {
        return;
      }
      if (!Number(this.allergen.Percentage)) {
        return;
      }
      if (this.allergen.Percentage > 100) {
        return;
      }
      this.items.push(this.allergen);
      this.allergen = {};
    },
    removeItem(item) {
      const index = this.items.indexOf(item);
      if (index > -1) {
        this.items.splice(index, 1);
      }
    }
  }
};
</script>

<style scoped>
.bor {
  border: solid grey 1px;
}
</style>
